export const copy = {

	bind: function (el, binding) {

		const handler = e => {
			if (el.contains(e.target) && el === e.target) {
				let textArea = document.createElement("textarea");
				textArea.value = binding.value;
				document.body.appendChild(textArea);
				textArea.select();
				document.execCommand("Copy");
				textArea.remove();
			}
		};

		el.clickTour = handler;

		document.addEventListener("click", handler);

	},
	unbind: function (el) {
		document.removeEventListener("click", el.clickTour);
	}
}